<app-view-item
  *ngIf="disabled"
  [text]="displayText"
  [borderless]="borderless"
></app-view-item>

<nz-select
  #selector
  *ngIf="!disabled"
  [nzBorderless]="borderless"
  [nzDisabled]="allowEdit === false"
  nzShowSearch
  [nzAllowClear]="true"
  [(ngModel)]="value"
  (ngModelChange)="onModelChange($event)"
  (nzOpenChange)="onOpenChanged($event)"
  [nzDropdownMatchSelectWidth]="false"
  (keydown)="handleKeyDown($event)"
  (click)="handleClick($event)"
  class="width-100"
>
  <ng-container *ngFor="let item of options">
    <nz-option
      [nzValue]="item.value"
      [nzLabel]="getLabel(item)"
      [nzDisabled]="disableOption004 && item.value === '004'"
      nzCustomContent
    >
      <div class="dropdown-container">
        <div class="width-lg max-width-xl">
          <strong>{{ item.value }}</strong>
          -
          <span> {{ item.name }}</span>
        </div>
      </div>
    </nz-option>
  </ng-container>
</nz-select>
